import { Home, Landmark, Scale, ArrowRight } from "lucide-react";

export const Audiences = () => {
  const audiences = [
    {
      icon: Home,
      title: "For Realtors",
      tagline: "Make Every Closing a Five-Star Experience",
      description: "Your reputation is built on successful closings. We ensure your clients' final impression of their home purchase is as exceptional as the journey you guided them through.",
      benefits: [
        "Smooth closings that reflect well on you",
        "Proactive issue resolution before closing day",
        "Flexible options for luxury and complex deals",
        "Same-day response to all inquiries",
      ],
    },
    {
      icon: Landmark,
      title: "For Loan Officers",
      tagline: "Keep Your Pipeline Moving",
      description: "Delays kill deals. Our proactive communication and attorney-led approach means title issues are resolved quickly, keeping your loans on track to close on time.",
      benefits: [
        "Reliable, on-time closings",
        "Clear communication at every stage",
        "Complex file expertise",
        "Lender requirement specialists",
      ],
    },
    {
      icon: Scale,
      title: "For Attorneys",
      tagline: "Precision Meets Partnership",
      description: "You need a title partner who understands legal nuance. Our attorney-led team handles complex transactions, unusual title issues, and multi-party deals with the sophistication your practice demands.",
      benefits: [
        "Attorney-to-attorney communication",
        "Complex transaction expertise",
        "Family law property transfers",
        "Technical precision guaranteed",
      ],
    },
  ];

  return (
    <section id="audiences" className="py-24 lg:py-32 bg-[#FAFAF9] noise-bg" data-testid="audiences-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-xs font-bold uppercase tracking-widest text-[#B45309] mb-4">Who We Serve</p>
          <h2 className="font-serif text-4xl md:text-5xl font-medium text-[#0F172A] tracking-tight mb-6">
            Built for Professionals Like You
          </h2>
          <p className="text-lg text-[#64748B] leading-relaxed">
            We understand what's at stake. Your success depends on flawless closings, 
            and that's exactly what we deliver.
          </p>
        </div>

        {/* Audience Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {audiences.map((audience, index) => (
            <div
              key={index}
              className="bg-white p-8 border border-[#E7E5E4] card-shadow group"
              data-testid={`audience-card-${index}`}
            >
              <div className="w-14 h-14 flex items-center justify-center border-2 border-[#0F172A] mb-6">
                <audience.icon className="w-6 h-6 text-[#0F172A]" strokeWidth={1.5} />
              </div>
              
              <p className="text-xs font-bold uppercase tracking-widest text-[#B45309] mb-2">
                {audience.title}
              </p>
              <h3 className="font-serif text-2xl font-medium text-[#0F172A] mb-4">
                {audience.tagline}
              </h3>
              <p className="text-[#64748B] leading-relaxed text-sm mb-6">
                {audience.description}
              </p>

              <ul className="space-y-3 mb-8">
                {audience.benefits.map((benefit, bIndex) => (
                  <li key={bIndex} className="flex items-center gap-3 text-sm text-[#64748B]">
                    <div className="w-1.5 h-1.5 bg-[#B45309] flex-shrink-0" />
                    {benefit}
                  </li>
                ))}
              </ul>

              <a
                href="#contact"
                className="inline-flex items-center gap-2 text-[#0F172A] font-bold text-xs uppercase tracking-widest group-hover:gap-3 transition-all"
              >
                Get Started
                <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
